import constants from "src/constants";

export type OgData = {
  title: string;
  language: string;
  metas: { property: string; content: string }[];
};

function getOg(
  lang: string,
  type: string,
  title: string,
  description: string,
  image: string
) {
  return {
    title: title,
    language: lang,
    metas: [
      { content: type, property: `og:type` },
      { property: `og:locale`, content: constants.Locales[lang].locale },
      { property: `og:title`, content: title },
      { property: `og:description`, content: description },
      { property: `og:image`, content: image },
    ],
  };
}

export default getOg;
